import React from "react";
import ComingSoon from "./CyberSecurity/ComingSoon";
const CyberSecurityMain = () => {
  return (
    <div>   
        <ComingSoon />
    </div>
    );
};

export default CyberSecurityMain;